import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { GuestGuard } from './core/guards/guest.guard';
import { LoginPage } from './pages/auth/login/login.page';
import { RegisterPage } from './pages/auth/register/register.page';
import { HomePage } from './pages/home/home.page';
import { ConvertPage } from './pages/convert/convert.page';
import { PlaylistsPage } from './pages/playlists/playlists.page';
import { AccountPage } from './pages/account/account.page';
import { LandingPage } from './pages/landing/landing.page';
import { ConnectCallbackPage } from './pages/connect-callback/connect-callback.page';
import { OauthSuccessPage } from './pages/oauth-success/oauth-success.page';
import { TokensInfoPage } from './pages/tokens-info/tokens-info.page';
import { TermsPage } from './pages/terms/terms.page';
import { PrivacyPage } from './pages/privacy/privacy.page';
import { CookieSettingsPage } from './pages/cookie-settings/cookie-settings.page';

const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: 'auth',
    children: [
      { path: 'login', component: LoginPage },
      { path: 'register', component: RegisterPage }
    ]
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomePage },
      { path: 'convert', component: ConvertPage },
      { path: 'convert/:conversionId', component: ConvertPage },
      { path: 'playlists', component: PlaylistsPage },
      { path: 'account', component: AccountPage },
      { path: 'tokens', component: TokensInfoPage },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  { path: 'oauth/success', component: OauthSuccessPage },
  { path: 'connect-callback', component: ConnectCallbackPage },
  { path: 'landing', component: LandingPage, canActivate: [GuestGuard] },
  { path: 'terms', component: TermsPage },
  { path: 'privacy', component: PrivacyPage },
  { path: 'settings', redirectTo: 'settings/cookies', pathMatch: 'full' },
  { path: 'settings/cookies', component: CookieSettingsPage },
  { path: '**', redirectTo: 'landing' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
